class BestsellersCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-bs-track]');
    this.slides = Array.from(section.querySelectorAll('[data-bs-slide]'));
    this.prevBtn = section.querySelector('[data-bs-prev]');
    this.nextBtn = section.querySelector('[data-bs-next]');
    this.current = 0;
    this.total = this.slides.length;
    this.mq = window.matchMedia('(max-width: 749px)');
    this.init();
  }

  init() {
    this.track.classList.add('bs-grid--slider');
    this.onBreakpoint = this.onBreakpoint.bind(this);
    this.mq.addEventListener('change', this.onBreakpoint);
    this.onBreakpoint({ matches: this.mq.matches });
    this.bindNav();
    this.bindSwipe();
    this.bindDrag();
  }

  getVisibleSlides() {
    return this.mq.matches ? 1 : 3;
  }

  getMaxIndex() {
    return Math.max(0, this.total - this.getVisibleSlides());
  }

  onBreakpoint() {
    this.current = Math.min(this.current, this.getMaxIndex());
    this.goTo(this.current, false);
  }

  goTo(index, animate = true) {
    const visibleSlides = this.getVisibleSlides();
    const shift = 100 / visibleSlides;
    this.current = Math.max(0, Math.min(index, this.getMaxIndex()));
    if (!animate) this.track.classList.add('bs-no-transition');
    this.track.style.transform = `translateX(-${this.current * shift}%)`;
    if (!animate) {
      this.track.offsetHeight;
      this.track.classList.remove('bs-no-transition');
    }
    this.syncNav();
  }

  syncNav() {
    const maxIndex = this.getMaxIndex();
    if (this.prevBtn) {
      this.prevBtn.disabled = this.current === 0;
      this.prevBtn.setAttribute('aria-disabled', String(this.current === 0));
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.current === maxIndex;
      this.nextBtn.setAttribute('aria-disabled', String(this.current === maxIndex));
    }
  }

  bindNav() {
    this.prevBtn?.addEventListener('click', () => this.goTo(this.current - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.current + 1));
  }

  bindSwipe() {
    let startX = 0;
    let startY = 0;
    this.track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    this.track.addEventListener('touchend', e => {
      const dx = startX - e.changedTouches[0].clientX;
      const dy = Math.abs(startY - e.changedTouches[0].clientY);
      if (Math.abs(dx) > 40 && Math.abs(dx) > dy) {
        this.goTo(dx > 0 ? this.current + 1 : this.current - 1);
      }
    }, { passive: true });
  }

  bindDrag() {
    const track = this.track;
    let startX = 0;
    let isDragging = false;
    let dragDelta = 0;
    let didDrag = false;

    track.addEventListener('mousedown', e => {
      if (e.button !== 0) return;
      startX = e.clientX;
      isDragging = true;
      dragDelta = 0;
      didDrag = false;
      track.classList.add('bs-no-transition', 'bs-dragging');
      e.preventDefault();
    });

    document.addEventListener('mousemove', e => {
      if (!isDragging) return;
      dragDelta = e.clientX - startX;
      if (Math.abs(dragDelta) > 4) didDrag = true;
      const visibleSlides = this.getVisibleSlides();
      const shift = 100 / visibleSlides;
      const base = -(this.current * shift);
      const containerW = track.parentElement.offsetWidth;
      const deltaPct = (dragDelta / containerW) * 100;
      track.style.transform = `translateX(${base + deltaPct}%)`;
    });

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('bs-no-transition', 'bs-dragging');
      if (didDrag) {
        const containerW = track.parentElement.offsetWidth;
        const visibleSlides = this.getVisibleSlides();
        const slideW = containerW / visibleSlides;
        const slidesOffset = Math.round(-dragDelta / slideW);
        this.goTo(this.current + slidesOffset);
      }
    };

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mouseleave', endDrag);

    track.addEventListener('click', e => {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);
  }
}

document.querySelectorAll('[data-bestsellers]').forEach(el => new BestsellersCarousel(el));

class GoldenFluffCollectionQuickAdd {
  constructor() {
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    document.addEventListener('click', this.onClick);
    document.addEventListener('submit', this.onSubmit);
  }

  getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async submitForm(form) {
    const button = form.querySelector('.bs-card__quickadd, .cpc-card__quickadd, [type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    const quantity = form.querySelector('[name="quantity"]')?.value || '1';

    if (!button || !variantId || button.disabled || button.dataset.loading === 'true') return;

    const loadingClass = button.classList.contains('bs-card__quickadd')
      ? 'bs-card__quickadd--loading'
      : button.classList.contains('gcc-card__plus')
        ? 'gcc-card__plus--loading'
        : 'cpc-card__quickadd--loading';
    const addedClass = button.classList.contains('bs-card__quickadd')
      ? 'bs-card__quickadd--added'
      : button.classList.contains('gcc-card__plus')
        ? 'gcc-card__plus--added'
        : 'cpc-card__quickadd--added';

    const cart = this.getCart();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    if (cart?.getSectionsToRender) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(section => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(button);
    }

    const originalHTML = button.innerHTML;
    button.dataset.loading = 'true';
    button.disabled = true;
    button.classList.add(loadingClass);

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const payload = await response.json();

      if (payload.status) {
        throw new Error(payload.description || payload.message || 'Cart add failed');
      }

      button.classList.remove(loadingClass);
      button.classList.add(addedClass);
      button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none"><path d="M1 7L6.5 12.5L17 1" stroke="#580800" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      if (cart?.renderContents && payload.sections) {
        cart.renderContents(payload);
        cart.classList.remove('is-empty');
      } else {
        window.location = window.routes?.cart_url || '/cart';
        return;
      }

      window.setTimeout(() => {
        button.classList.remove(addedClass);
        button.innerHTML = originalHTML;
        button.disabled = false;
        delete button.dataset.loading;
      }, 1800);
    } catch (error) {
      console.error(error);
      button.classList.remove(loadingClass);
      button.disabled = false;
      delete button.dataset.loading;
    }
  }

  onClick(event) {
    const button = event.target.closest('[data-gf-quick-add-button]');
    if (!button) return;

    const form = button.closest('[data-gf-quick-add-form]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    this.submitForm(form);
  }

  onSubmit(event) {
    const form = event.target.closest('[data-gf-quick-add-form]');
    if (!form) return;

    event.preventDefault();
    this.submitForm(form);
  }
}

if (!window.goldenFluffCollectionQuickAdd) {
  window.goldenFluffCollectionQuickAdd = new GoldenFluffCollectionQuickAdd();
}

class FamilyReviewsRail {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-gfr-track]');

    if (!this.track) return;

    this.pointerActive = false;
    this.pointerId = null;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.wasDragging = false;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClickCapture = this.onClickCapture.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerUp);
    this.track.addEventListener('pointerleave', this.onPointerUp);
    this.track.addEventListener('click', this.onClickCapture, true);
    this.track.addEventListener('keydown', this.onKeyDown);
  }

  getScrollAmount() {
    const card = this.track.querySelector('[data-gfr-card]');
    if (!card) return this.track.clientWidth * 0.8;

    const trackStyles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

    return card.getBoundingClientRect().width + gap;
  }

  onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    this.pointerActive = true;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
    this.wasDragging = false;

    this.track.classList.add('is-dragging');
    this.track.setPointerCapture?.(event.pointerId);
  }

  onPointerMove(event) {
    if (!this.pointerActive) return;

    const deltaX = event.clientX - this.startX;
    if (Math.abs(deltaX) > 6) this.wasDragging = true;

    this.track.scrollLeft = this.startScrollLeft - deltaX;
  }

  onPointerUp() {
    if (!this.pointerActive) return;

    this.pointerActive = false;
    this.track.classList.remove('is-dragging');

    if (this.pointerId !== null) {
      try {
        this.track.releasePointerCapture?.(this.pointerId);
      } catch {}
    }

    this.pointerId = null;

    window.setTimeout(() => {
      this.wasDragging = false;
    }, 0);
  }

  onClickCapture(event) {
    if (!this.wasDragging) return;

    event.preventDefault();
    event.stopPropagation();
  }

  onKeyDown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    event.preventDefault();

    const direction = event.key === 'ArrowRight' ? 1 : -1;
    this.track.scrollBy({
      left: direction * this.getScrollAmount(),
      behavior: 'smooth',
    });
  }

  destroy() {
    if (!this.track) return;

    this.track.removeEventListener('pointerdown', this.onPointerDown);
    this.track.removeEventListener('pointermove', this.onPointerMove);
    this.track.removeEventListener('pointerup', this.onPointerUp);
    this.track.removeEventListener('pointercancel', this.onPointerUp);
    this.track.removeEventListener('pointerleave', this.onPointerUp);
    this.track.removeEventListener('click', this.onClickCapture, true);
    this.track.removeEventListener('keydown', this.onKeyDown);
  }
}

function getFamilyReviewsSections(container = document) {
  if (container.matches?.('[data-family-reviews]')) return [container];
  return Array.from(container.querySelectorAll('[data-family-reviews]'));
}

function initFamilyReviewsSections(container = document) {
  getFamilyReviewsSections(container).forEach(section => {
    if (section.familyReviewsRail) return;
    section.familyReviewsRail = new FamilyReviewsRail(section);
  });
}

function destroyFamilyReviewsSections(container = document) {
  getFamilyReviewsSections(container).forEach(section => {
    section.familyReviewsRail?.destroy();
    delete section.familyReviewsRail;
  });
}

initFamilyReviewsSections();

document.addEventListener('shopify:section:load', event => {
  initFamilyReviewsSections(event.target);
});

document.addEventListener('shopify:section:unload', event => {
  destroyFamilyReviewsSections(event.target);
});

class FamilyFaq {
  constructor(section) {
    this.section = section;
    this.singleOpen = section.dataset.singleOpen === 'true';
    this.items = Array.from(section.querySelectorAll('[data-ffq-item]'));

    if (!this.items.length) return;

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach(item => {
      item.querySelector('[data-ffq-trigger]')?.addEventListener('click', this.onTriggerClick);
    });
  }

  onTriggerClick(event) {
    const item = event.currentTarget.closest('[data-ffq-item]');
    if (!item) return;

    this.toggleItem(item);
  }

  toggleItem(targetItem, forceOpen) {
    const isOpen = targetItem.classList.contains('is-open');
    const nextOpenState = typeof forceOpen === 'boolean' ? forceOpen : !isOpen;

    if (nextOpenState && this.singleOpen) {
      this.items.forEach(item => {
        if (item !== targetItem) this.setItemState(item, false);
      });
    }

    this.setItemState(targetItem, nextOpenState);
  }

  setItemState(item, isOpen) {
    const trigger = item.querySelector('[data-ffq-trigger]');
    const panel = item.querySelector('[data-ffq-panel]');

    if (!trigger || !panel) return;

    item.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    panel.hidden = !isOpen;
  }

  onBlockSelect(event) {
    const block = event.target.closest('[data-ffq-item]');
    if (!block || !this.section.contains(block)) return;

    this.toggleItem(block, true);
  }

  destroy() {
    this.items.forEach(item => {
      item.querySelector('[data-ffq-trigger]')?.removeEventListener('click', this.onTriggerClick);
    });
  }
}

function getFamilyFaqSections(container = document) {
  if (container.matches?.('[data-family-faq]')) return [container];
  return Array.from(container.querySelectorAll('[data-family-faq]'));
}

function initFamilyFaqSections(container = document) {
  getFamilyFaqSections(container).forEach(section => {
    if (section.familyFaqInstance) return;
    section.familyFaqInstance = new FamilyFaq(section);
  });
}

function destroyFamilyFaqSections(container = document) {
  getFamilyFaqSections(container).forEach(section => {
    section.familyFaqInstance?.destroy();
    delete section.familyFaqInstance;
  });
}

initFamilyFaqSections();

document.addEventListener('shopify:block:select', event => {
  const section = event.target.closest('[data-family-faq]');
  if (!section?.familyFaqInstance) return;
  section.familyFaqInstance.onBlockSelect(event);
});

document.addEventListener('shopify:section:load', event => {
  initFamilyFaqSections(event.target);
});

document.addEventListener('shopify:section:unload', event => {
  destroyFamilyFaqSections(event.target);
});

class PopcornJourneyTimeline {
  constructor(section) {
    this.section = section;
  }

  onBlockSelect(event) {
    const item = event.target.closest('[data-pjt-item]');
    if (!item || !this.section.contains(item)) return;

    item.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  }

  destroy() {}
}

function getPopcornJourneySections(container = document) {
  if (container.matches?.('[data-popcorn-journey]')) return [container];
  return Array.from(container.querySelectorAll('[data-popcorn-journey]'));
}

function initPopcornJourneySections(container = document) {
  getPopcornJourneySections(container).forEach(section => {
    if (section.popcornJourneyInstance) return;
    section.popcornJourneyInstance = new PopcornJourneyTimeline(section);
  });
}

function destroyPopcornJourneySections(container = document) {
  getPopcornJourneySections(container).forEach(section => {
    section.popcornJourneyInstance?.destroy();
    delete section.popcornJourneyInstance;
  });
}

initPopcornJourneySections();

document.addEventListener('shopify:block:select', event => {
  const section = event.target.closest('[data-popcorn-journey]');
  if (!section?.popcornJourneyInstance) return;
  section.popcornJourneyInstance.onBlockSelect(event);
});

document.addEventListener('shopify:section:load', event => {
  initPopcornJourneySections(event.target);
});

document.addEventListener('shopify:section:unload', event => {
  destroyPopcornJourneySections(event.target);
});

class FullVideoSection {
  constructor(section) {
    this.section = section;
    this.player = section.querySelector('[data-full-video]');
    this.trigger = section.querySelector('[data-fvd-trigger]');
    this.template = section.querySelector('[data-fvd-template]');
    this.mediaContainer = section.querySelector('[data-fvd-media]');
    this.autoplayOnLoad = this.player?.dataset.autoplayOnLoad === 'true';
    this.hasVideo = this.player?.dataset.hasVideo === 'true';
    this.loaded = false;

    if (!this.player || !this.template || !this.mediaContainer || !this.hasVideo) return;

    this.onTriggerClick = this.onTriggerClick.bind(this);

    this.bindEvents();

    if (this.autoplayOnLoad) {
      this.loadMedia();
    }
  }

  bindEvents() {
    this.trigger?.addEventListener('click', this.onTriggerClick);
  }

  onTriggerClick() {
    this.loadMedia();
  }

  loadMedia() {
    if (this.loaded) {
      this.playMedia();
      return;
    }

    if (typeof pauseAllMedia === 'function') pauseAllMedia();

    this.mediaContainer.innerHTML = '';
    this.mediaContainer.appendChild(this.template.content.cloneNode(true));
    this.mediaContainer.hidden = false;
    this.player.classList.add('is-loaded');

    this.loaded = true;
    this.playMedia();
  }

  playMedia() {
    const video = this.mediaContainer.querySelector('video');
    if (!video) return;

    const playAttempt = video.play?.();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(() => {});
    }
  }

  destroy() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);

    const video = this.mediaContainer?.querySelector('video');
    video?.pause?.();
  }
}

function getFullVideoSections(container = document) {
  if (container.matches?.('.fvd-section')) return [container];
  return Array.from(container.querySelectorAll('.fvd-section'));
}

function initFullVideoSections(container = document) {
  getFullVideoSections(container).forEach(section => {
    if (section.fullVideoInstance) return;
    section.fullVideoInstance = new FullVideoSection(section);
  });
}

function destroyFullVideoSections(container = document) {
  getFullVideoSections(container).forEach(section => {
    section.fullVideoInstance?.destroy();
    delete section.fullVideoInstance;
  });
}

initFullVideoSections();

document.addEventListener('shopify:section:load', event => {
  initFullVideoSections(event.target);
});

document.addEventListener('shopify:section:unload', event => {
  destroyFullVideoSections(event.target);
});

/* ============================================================
   LINKED FLAVOR PICKER
   ============================================================ */

class LinkedFlavorPicker {
  constructor(el) {
    this.pills = Array.from(el.querySelectorAll('.linked-flavor-pill'));
    this.pills.forEach(pill => {
      pill.addEventListener('click', () => this.switchTo(pill));
    });
  }

  switchTo(pill) {
    if (pill.classList.contains('linked-flavor-pill--active')) return;
    const handle = pill.dataset.handle;
    if (handle) {
      window.location.href = '/products/' + handle;
    }
  }

}

document.querySelectorAll('[data-linked-flavors]').forEach(el => new LinkedFlavorPicker(el));

function gfInitStickyAtc() {
  const bar = document.querySelector('.gf-sticky-atc');
  if (!bar) return;

  // Move to body so position:fixed is never trapped by a parent stacking context
  document.body.appendChild(bar);

  const priceEl = bar.querySelector('.gf-sticky-atc__price');
  const titleEl = bar.querySelector('.gf-sticky-atc__title');
  const btn = bar.querySelector('.gf-sticky-atc__btn');

  // Find the real ATC button without relying on section IDs
  const mainBtn = document.querySelector('product-info [name="add"]')
    || document.querySelector('form[id^="product-form"] [name="add"]')
    || document.querySelector('.product-form__submit[name="add"]');

  // Sync sticky bar button state from the main button
  function syncBtnState() {
    if (!btn || !mainBtn) return;
    var isDisabled = mainBtn.disabled;
    btn.disabled = isDisabled;
    btn.textContent = isDisabled ? 'Sold Out' : 'Add to Cart';
  }

  // Watch main button for Dawn's variant JS updating disabled state
  if (mainBtn) {
    syncBtnState();
    new MutationObserver(syncBtnState).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  function checkScroll() {
    var show;
    if (mainBtn) {
      var rect = mainBtn.getBoundingClientRect();
      show = rect.bottom < 0 || rect.top > window.innerHeight;
    } else {
      show = window.scrollY > 350;
    }
    bar.classList.toggle('gf-sticky-atc--visible', show);
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  if (btn) {
    btn.addEventListener('click', function() {
      var realBtn = document.querySelector('product-info [name="add"]')
        || document.querySelector('form[id^="product-form"] [name="add"]');
      if (realBtn && !realBtn.disabled) realBtn.click();
    });
  }

  document.addEventListener('click', function(e) {
    var pill = e.target.closest('.linked-flavor-pill');
    if (!pill) return;
    var price = pill.dataset.price;
    var title = pill.dataset.title;
    var available = pill.dataset.available;
    if (price && priceEl) priceEl.textContent = price;
    if (title && titleEl) titleEl.textContent = title;
    if (btn) {
      var avail = available === 'true';
      btn.disabled = !avail;
      btn.textContent = avail ? 'Add to Cart' : 'Sold Out';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', gfInitStickyAtc);
} else {
  gfInitStickyAtc();
}
